// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'

import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import BootstrapVue from 'bootstrap-vue'
import Toaster from 'v-toaster'
import VeeValidate from 'vee-validate'
import Multiselect from 'vue-multiselect'
import Vuetable from 'vuetable-2'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import * as VueMenu from '@hscmap/vue-menu'
import VueColumnsResizable from 'vue-columns-resizable'
// import CKEditor from '@ckeditor/ckeditor5-vue'

// import 'v-toaster/dist/v-toaster.css'
const moment = require('moment')
require('moment/locale/fr')
Vue.use(require('vue-moment'), {
  moment
})
Vue.use(BootstrapVue)
Vue.use(Toaster, { timeout: 5000 })
Vue.use(VeeValidate, {
  validity: true,
  fieldsBagName: 'formFields'
})
Vue.use(Vuetable)
Vue.use(VueMenu)
Vue.use(VueColumnsResizable)
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)

// Vue.use(CKEditor)

library.add(fas)
library.add(far)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('multiselect', Multiselect)
Vue.component('vuetable', Vuetable)
Vue.prototype.$http = axios

const token = localStorage.getItem('token')

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.config.productionTip = false

export const eventBus = new Vue()
Vue.config.devtools = true
/* const constantMock = window.fetch
window.fetch = function () {
  // Get the parameter in arguments
  // Intercept the parameter here
  const option = { method: 'GET', headers: { 'Content-Type': 'application/json' } }
  return constantMock.call(this, arguments[0], option)
} */

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js